import React from 'react';
import PropTypes from 'prop-types';

function DialogsEmoji({ className = 'dialog-body__emoji', label, html }) {
  return (
    <span
      className={className}
      role="img"
      aria-label={label}
      /* eslint-disable-next-line yola/react/no-danger */
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

DialogsEmoji.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  html: PropTypes.string.isRequired,
};

export default DialogsEmoji;
